module.exports = "pegasus_template/assets/lp/product/bg0.png";